export default __webpack_public_path__ + "static/char-s-21-ja-391e3115ae66b2fb180b34d17632b9c2.png";